import { ChainId } from '@babydogeswap/sdk'
import { BLOCKED_ADDRESSES } from './babydogeswap'
import { testnetTokens, mainnetTokens } from './tokens'

export const BLOCKED_FARMS_POOLS = [
  ...BLOCKED_ADDRESSES,
  '0x3ee921e659D54d3661968Ba29e17F8C5ea5275f9' // Old Pool - BabyDoge -> BabyDoge
]

export const ALERT_FARMS_POOLS = {
  [ChainId.MAINNET]: [
    '0x75aFA9915B2210Cd6329E820af0365e932bC1dd5', // SMURF Token
    '0xC2D5F369d6A1B2de098b0b57E05bBc20967d704A', // inc Token
    '0x0416846Db6bEa02588e546271D4d83c4061b7757', // FOOTBALL
    '0x47Bee374d4dd5e6C11f7f8Bcf817ccBc6696d719' // Bib
  ],
  [ChainId.TESTNET]: []
}

export const HOT_FARMS_POOLS = {
  [ChainId.MAINNET]: [
    // Farms
    '0x9CcB41A29811608e633A030f9aD6a2aEe34Fcd10'
    // Pools
  ],
  [ChainId.TESTNET]: []
}

export const TREAT_FARMS_POOLS = {
  [ChainId.MAINNET]: [],
  [ChainId.TESTNET]: [
    '0x5793b1733c29d90c6ffcfac9cb0acc93817324d5',
    '0x68f8a92f0064da8f4fb4d20bee8f3e64c74b1f84',
    '0x7cc63a975e630f8ad0f9f75227c9b9347e91a308',
    '0xda31747af22ddabd0884c3e97f412ac8d8f8420e'
  ]
}

export const CORE_FARMS_POOLS = {
  [ChainId.MAINNET]: [
    ...TREAT_FARMS_POOLS[ChainId.MAINNET],
    // Farms
    //live
    '0xdf8e4b11bd68b1e81a9b57b71ff04fbcd9efd0cf', // BNB/Wateen -> Wateen
    '0x13EE4FC9f3B2eD87146a1932e49a4D7077B13A7F', // BNB/BabyDoge -> Wateen
    '0xE5174533d8B07228183184a7AC95963B2078e2cE', // DOGE/USDT -> BabyDoge
    '0x4aa6f6778d48f2c30b712a7ce47b073afada806b', // ETH/BNB -> BabyDoge
    '0xeaef88568265d54c5cb1e213bdd35a4028b8fb84', // DOGE/BNB -> BabyDoge
    '0x12afe3f3bdc7dc171cc1db8dd47917bda3f813a0', // BTC/BNB -> BabyDoge
    '0x332404fd2ddf1f1ff35a7eee95375cc1323fb2df', // BNB/BUSD -> BabyDoge
    '0xf0ab4371857487c41f042bc63ee7c96091a9e99c', // USDT/BNB -> BabyDoge
    '0x3fdbaf9ee8ad48d2bd9204210234afb4ad651fb0', // USDT/BUSD -> BabyDoge
    '0x9CcB41A29811608e633A030f9aD6a2aEe34Fcd10', // BNB/BabyDoge -> BabyDoge
    // ended
    '0xccbf315f768bf0aeafa53f11f6ed67d5e4bb7f7d', // BabyDoge/USDT -> BabyDoge
    '0x70bfa2aa39499d06cfe9ac83b20650b81607dfb9', // BTC/USDT -> BabyDoge
    '0x2228a135f83afef56fae86ea4aa844b339e0fc0e', // BNB/BabyDoge -> BabyDoge
    // Pools
    //live
    '0xcecd3e7eadae1ad0c94f53bf6a2af188df1a90d0' // BabyDoge -> BabyDoge
    //ended
  ],
  [ChainId.TESTNET]: [...TREAT_FARMS_POOLS[ChainId.TESTNET], '0x92d4517c98d739193863ad739cb55f998c992f22']
}

export const KYCD_FARMS_POOLS = {
  [ChainId.MAINNET]: [
    // Farms
    '0x6c4a62f5907cafa0256d47e14116c9b9f3b53c0c', // LST/BUSD -> LST
    '0xbaBd540977c4c7133Fdde0dD42d665516842638F', // HVI/BUSD
    '0x1f66cbc69b602e937c2397229ca65e7ea5ed01b6', // VIZSLASWAP/BNB
    '0xceAe004db99d4BF8Cfe618854c96747794eF1F79', // SHIDO/BNB
    '0x3FA07bEfa17245cBf8dBBeECf94813B856D44157', // BURN/BNB
    '0x4066589193db01c82b3ad3f24894d40a457fb4c8', // GVR/BNB
    '0x4e6394a669c4b6ac643194ca257301910e210f06', // CHRP/BNB
    '0xb151d0259049b2f8f93095948ef18110a44e3c19', // $MUU/BNB
    '0x3874e8e72c2be99548bef940dd0b8838fba2b615', // IMT/BNB
    '0x44A1C9775F6242d4753f992Cc36432c1Ab72Aa14',
    '0x6972fc241fde4a3d36f6cf66cb35eee084632d72', // Sweep->BNB Farm
    '0xe91aa91f38c019b941fc40e16d62ed2b0cc68997', // Sweep->Babydoge
    '0xb6d4362Bd545B9Ef92d3E746F6fc789Ef4037B6B', // LGC->BNB
    '0x7E097DE01B103Dbc999da343BA1814c7b464d731', // CR1->BNB
    '0xCd7d54a8090d2E4B98B204BAfe10f3DAf353E99F', // BNB/TXS -> TXS
    '0xb72E25e3AF94143c7D04A21b63ca51aef684fdd7', // PRIMAL/USDT -> PRIMAL
    '0xF356057837Bbab098442CEe66D4767fffD105bce', // Mazi/BNB -> Mazi
    '0xEC297491119a41F4803451B3431d2da1De7797a5', // KATA/BNB -> KATA
    '0xdb864b497e05827b650e93ae4c61c2488c6dab9c', // FLOKICEO/BNB -> FLOKI
    '0x68D51E214762feB78346888402861cc493C01E7C', // oggy/bnb -> oggy
    // Pools
    '0x5332b9eC156331e085df806225B7383B37cEd17b', // Sweep -> Sweep
    '0x8a30C07809308A602f52D3C7Ca2eC51704f411d8', // LCG -> LCG
    '0x36ce48bE451d9E909fCa7EF81cB02f76E08D94e7', // Grove
    '0xc55e9D53B55C3Fe0e2ee818EE646eB99671e76a4', // BURNT
    '0xfa2aa24902B1bF0F83a46b3e1b82EeeDF26B8081', // BabyDoge -> BURNT
    '0x4A301D3bB63927b5c52BcfB664FF0491D3F767E0', // BURN -> BURNT
    '0x142861ea3cAeD236613FA921eFbE855bcc47716F', // VIZLA -> VIZLA
    '0x65A945D59f194961c6Ae428Bb9cC112283c588Cc', // BURNT -> BUSD
    '0x08D08dDb9D083d801F4125B7CA52FbCAe9b8d012', // LCG -> VIZSLASWAP
    '0x2A88093C8B565D6D47Fa01B160e1f52FF9f88715', // LCG -> USDT
    '0xf049DD07F5ef1Feb4327233CE8DD7B640280507f', // VIZSLASWAP -> LCG
    '0x88D1e3CED3C7AC69D627b9e42A6484a4301BfE43', // CrazyBunny -> CrazyBunny

    '0xf442cf7af239fb162d99099009e800df9ac36716', // Sweep
    '0x8f82951b6275a490639396fd83f67ce47aab0594',
    '0xada8eb144385790669b720265dec530557594359',
    '0xcb4b89c017b1e662e1358b56576a19c644f8fd1d',
    '0xee5de106a5c9947d5511d503e3a440217786b6b6', // Old Gamer Guru Token
    '0xe87cd656c55091e7354a461bf3acd1426e9fd38d',
    '0x4BA7aB8Df178ee42EE0B2080103048cB63BD20b1', // New Gamer Guru Token(WBNB/GGT -> GGT)
    '0x4ad831255656614b405751a51764c323696601a2', // BabyDoge -> LGC
    '0x534B1967Ee20AA56B2E73D67Ce865Ce9C09A2333', // USDT/NFTL -> NFTL
  ],
  [ChainId.TESTNET]: []
}

export const STABLES = {
  [ChainId.MAINNET]: [mainnetTokens.busd.address, mainnetTokens.usdc.address, mainnetTokens.usdt.address],
  [ChainId.TESTNET]: [testnetTokens.busd.address, testnetTokens.usdc.address, testnetTokens.usdt.address]
}
